import { useStore as u } from "zustand";
function n(e) {
  return (r) => u(e.store, r ?? ((o) => o));
}
function i(e, t) {
  return n(e)(t ?? ((o) => o));
}
export {
  i as default,
  n as useCreateNotificationStore
};
//# sourceMappingURL=useNotificationStore.mjs.map
